module.exports = ['DataService', function(DataService) {
    const _service = this;

    let _currentPromise    = false,
        _currentCampaign   = false,
        _currentCampaignId = false;


    /**
     * Load the campaign from the API
     * @return {boolean}
     */
    function loadCampaign() {
        if(!_currentCampaignId) throw new Error('No Campaign ID is set!');

        let campaignParams = {},
            authCode = _service.authCode();

        if(authCode) {
            campaignParams.auth_code = authCode;
        }

        if(!_currentPromise) {
            _currentPromise = DataService.getCampaign(_currentCampaignId, campaignParams)
                                         .then((campaign) => (_currentCampaign = campaign));
        }

        return _currentPromise;
    }

    /**
     * Get the current campaign (deferred)
     */
    _service.get = loadCampaign;

    /**
     * Get the already loaded campaign
     * (can be false if nop campaign was loaded)
     */
    _service.getSync = () => _currentCampaign;

    /**
     * Set an id for the current campaign
     * @param id
     */
    _service.set = (id) => {
        _currentCampaignId = id;
        _currentCampaign   = false;
        _currentPromise    = false;

        return _service.get();
    };

    _service.authCode = () => {
        const authCodeRegEx = /auth_code=([a-z0-9]+)/i,
              authCodeMatches = authCodeRegEx.exec(location.search);

        return (Array.isArray(authCodeMatches) && authCodeMatches.length == 2) ? authCodeMatches[1] : false;
    };
}];
